import { css } from 'styled-components';

const flexCenter = css `
    display: flex;
    align-items: center;
    justify-content: center;
`;
const cssReset = css `
    * {
        margin: 0;
        padding: 0;
    }

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    a {
        text-decoration: none;
    }

    img,
    svg {
        display: block;
        max-width: 100%;
    }

    input,
    button,
    textarea,
    select {
        font: inherit;
    }
`;

export { cssReset, flexCenter };
//# sourceMappingURL=style-mixins.js.map
